<template>
  <div class="container">
    <p>
      <strong>Code Value: {{ codeValue }} </strong>
    </p>
    <div class="qr-container">
      <qrcode-vue :value="codeValue" :size="200" level="H"></qrcode-vue>
      <h4>QR Generator - Instructions</h4>
      <div class="row">
        <div class="col">
          <p>Pick a deeplink path you want to test</p>
          <p>Click "Generate" button</p>
          <p>
            Scan QR code below from your mobile device's native camera or in
            OneApp.
          </p>
        </div>
        <div class="row">
          <div class="input-group mb-3">
            <label class="input-group-text" for="selected">
              Select a Deeplink</label
            >
            <select
              class="form-select"
              aria-label="Select a deeplink"
              v-model="selectedPath"
            >
              <option selected value="existing-account">
                Existing Account
              </option>
              <option value="launch-oneapp">Launch OneApp</option>
              <option value="sms_registration">Registration</option>
              <option value="manage-garage">Manage Garage</option>
              <option value="manage-profile">Manage Profile</option>
              <option value="manage-dynamicnavi">Manage Dynamic Navi</option>
              <option value="manage-subscriptions">Manage Subscriptions</option>
              <option value="last-parked">Last Parked</option>
              <option value="guest-driver">Guest Driver</option>
              <option value="remote">Remote</option>
              <option value="schedule-service">Schedule Service</option>
              <option value="sms_registration">Registration</option>
              <option value="sms_linkaccounts">Link Accounts</option>
              <option value="sms_subscriptions">Subscriptions</option>
              <option value="sms_pinreset">Pin Reset</option>
              <option value="sms_dk_share">DK Share</option>
              <option value="sms_remoteaccess">Remote Access</option>
              <option value="password_reset">Password Reset** new!</option>
            </select>
          </div>
          <div class="input-group mb-3">
            <label class="input-group-text" for="selected"
              >Select a Brand</label
            >
            <select
              class="form-select"
              aria-label="Select a brand"
              v-model="selectedBrand"
            >
              <option selected value="Toyota">Toyota</option>
              <option value="Lexus">Lexus</option>
              <option value="Subaru">Subaru</option>
            </select>
          </div>
          <div class="input-group mb-3">
            <label class="input-group-text" for="selected"
              >Select an Environment</label
            >
            <select
              class="form-select"
              aria-label="Select an environment"
              v-model="selectedEnvironment"
            >
              <option selected value="PROD">PROD</option>
              <option value="NONPROD">NON-PROD</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button
            class="btn btn-danger"
            v-on:click="generate"
            :disabled="!selectedPath || !selectedBrand || !selectedEnvironment"
          >
            Generate
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { analytics } from "../../config/firebaseInit";

export default {
  name: "QrDeepLinks",
  data: function () {
    return {
      codeValue: "",
      selectedBrand: "Toyota",
      selectedEnvironment: "PROD",
      selectedPath: "existing-account",
      scanResponse: null,
    };
  },
  props: {
    msg: String,
  },
  components: {
    QrcodeVue,
  },
  created() {
    analytics.logEvent("qr-deeplinks");
  },
  methods: {
    generate: function () {
      console.log("generate");
      const brandPathProd = {
        Toyota: "https://cttoyotaapp.com",
        Lexus: "https://ctlexusapp.com",
        Subaru: "https://subaru.app.link",
      };
      const brandPathNonProd = {
        Toyota: "https://toyota.test-app.link",
        Lexus: "https://lexus.test-app.link",
        Subaru: "https://subaru.test-app.link",
      };
      const brandPath =
        this.selectedEnvironment === "PROD" ? brandPathProd : brandPathNonProd;
      const setBrandPath = brandPath[this.selectedBrand];
      console.log(setBrandPath);
      this.codeValue = `${setBrandPath}/${this.selectedPath}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
body {
  font-family: ToyotaType-Regular;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ty-button {
  background: #d92429;
  border-radius: 0px;
  width: 343px;
  height: 64px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}

.qr-container {
  padding-top: 40px;
  text-align: center;
  height: 300px;
  /*background-color: #4281ff;*/
  height: 540px;
}
</style>
